import { api } from './api';
import type { SiteConfig, UpdateConfigInput } from '../types/entities';

export const configService = {
  /**
   * Get site configuration
   */
  async get(): Promise<SiteConfig> {
    const response = await api.get<SiteConfig>('/api/admin/config');
    return response.data;
  },

  /**
   * Update site configuration
   */
  async update(data: UpdateConfigInput): Promise<SiteConfig> {
    const response = await api.put<SiteConfig>('/api/admin/config', data);
    return response.data;
  },
};
